import * as React from 'react';
import styled from 'styled-components';

import PrivacyView from '../../components/settings/settingsItems/PrivacyView';
import Colors from '../../styles/colors';
import CommonBG from '../uiElements/CommonBG';
import { HeaderOptions } from '../uiElements/Header';

const headerOptions: HeaderOptions = {
  buttonType: 'close',
  hideHomeButton: true,
};

interface DialogPrivacyViewProps {}
const DialogPrivacyView: React.FC<DialogPrivacyViewProps> = props => {
  return (
    <CommonBG withHeader headerOptions={headerOptions} withFooter>
      <Wrapper>
        <PrivacyView />
      </Wrapper>
    </CommonBG>
  );
};

const Wrapper = styled.div`
  padding: 2rem 4rem;
`;

export default DialogPrivacyView;
